import { z } from "zod";

import type { LogoModel } from "./CreateTypes";

export interface SearchResultModel {
	id: string;
	name: string;
	address: string;
	link?: string;
	logo?: LogoModel | null;
}

export const paginationTokenResolver = z.string().nullable().optional();
export type PaginationTokenType = z.infer<typeof paginationTokenResolver>;

export interface PaginationParamsModel {
	limit?: number;
	after?: PaginationTokenType;
	before?: PaginationTokenType;
}

export interface PaginationSearchModel extends PaginationParamsModel {
	search?: string;
	limit?: number;
	after?: string;
	// role?: Roles;
}
